import { createSlice } from "@reduxjs/toolkit";

const newsCategoriesSlice = createSlice({
  name: "newsCategories",
  initialState: {
    newsCategoriesList: [],
    newsCategoriesListAll: [],
    isFetching: false,
    isFetchingAll: false,
    isLoggedIn: false,
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getNewsCategories: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getNewsCategoriesSuccess: (state, action) => {
      state.isFetching = false;
      state.newsCategoriesList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getNewsCategoriesFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getNewsCategoriesAll: (state) => {
      state.isFetchingAll = true;
      state.error = false;
    },
    getNewsCategoriesAllSuccess: (state, action) => {
      state.isFetchingAll = false;
      state.newsCategoriesListAll = action.payload.data
      state.error = false;
    },
    getNewsCategoriesAllFailed: (state) => {
      state.isFetchingAll = false;
      state.error = true;
    },
    addNewsCategories: (state) => {
      state.isFetching = true
      state.error = false
    },
    addNewsCategoriesSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addNewsCategoriesFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateNewsCategories: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateNewsCategoriesSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateNewsCategoriesFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeNewsCategories: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeNewsCategoriesSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeNewsCategoriesFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const newsCategoriesActions = newsCategoriesSlice.actions;
export default newsCategoriesSlice.reducer;
